import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateRoleDocument } from './update.generated';

export const useUpdateRole = (options: ApiOptions<typeof UpdateRoleDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(UpdateRoleDocument, {
    ...useNotifications(UpdateRoleDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.roles.update_success'),
    }),

    ...options,
  });
};
